import { useQuery } from "@tanstack/react-query";
import { searchMessages } from "../lib/api-client";
import { mailboxQueryKeys } from "../lib/query-keys";

/** `q` is expected to already be debounced by the caller (see components/mail/search-bar.tsx). */
export function useSearch(mailboxId: string | undefined, q: string) {
  const trimmed = q.trim();
  return useQuery({
    queryKey: mailboxQueryKeys.search(mailboxId ?? "", trimmed),
    queryFn: () => searchMessages(mailboxId!, trimmed),
    enabled: Boolean(mailboxId) && trimmed.length > 0,
    staleTime: 15_000,
  });
}
